export default __webpack_public_path__ + "0d8bbd770e3ffec23d44303a2f93970b.png";